import countries from 'i18n-iso-countries';
import en from 'i18n-iso-countries/langs/en.json';

countries.registerLocale(en);

// IOC / NOC codes that differ from ISO 3166-1 alpha-3
const NOC_ALPHA3_TO_ALPHA2 = {
  ALG: 'DZ',
  PAR: 'PY',
  USA: 'US',
  GBR: 'GB',
  ENG: 'GB',
  SCO: 'GB',
  WAL: 'GB',
  NIR: 'GB',
  KOR: 'KR',
  PRK: 'KP',
  CHN: 'CN',
  TPE: 'TW',
  UAE: 'AE',
  NED: 'NL',
  SUI: 'CH',
  GER: 'DE',
  RSA: 'ZA',
  PHI: 'PH',
  PUR: 'PR',
  DOM: 'DO',
  CRC: 'CR',
  PAN: 'PA',
  BAH: 'BS',
  BER: 'BM',
  CAY: 'KY',
  HKG: 'HK',
  IRL: 'IE',
  DEN: 'DK',
  CRO: 'HR',
  SLO: 'SI',
  SVK: 'SK',
  CZE: 'CZ',
  MAS: 'MY',
  THA: 'TH',
  INA: 'ID',
  VIE: 'VN',
  NZL: 'NZ',
  AUT: 'AT',
  BEL: 'BE',
  BUL: 'BG',
  CYP: 'CY',
  EST: 'EE',
  FIN: 'FI',
  GEO: 'GE',
  GRE: 'GR',
  ISL: 'IS',
  ISR: 'IL',
  ITA: 'IT',
  JPN: 'JP',
  KAZ: 'KZ',
  LAT: 'LV',
  LTU: 'LT',
  LUX: 'LU',
  MEX: 'MX',
  NOR: 'NO',
  POL: 'PL',
  POR: 'PT',
  ROU: 'RO',
  RUS: 'RU',
  SGP: 'SG',
  ESP: 'ES',
  SWE: 'SE',
  TUR: 'TR',
  UKR: 'UA',
  URU: 'UY',
  VEN: 'VE',
  ZIM: 'ZW',
  ARG: 'AR',
  AUS: 'AU',
  BRA: 'BR',
  CAN: 'CA',
  CHI: 'CL',
  COL: 'CO',
  ECU: 'EC',
  FRA: 'FR',
  IND: 'IN',
};

const NOC_FLAG_FILE_OVERRIDES = {
  AIN: 'ain',
  TPE: 'tpe',
};

// Bump when flag SVG assets change so browsers don't reuse stale cached images.
const FLAG_ASSET_VERSION = '20260619';

/** ISO / NOC alpha-3 → alpha-2 for flag images */
export const countryToAlpha2 = (code) => {
  if (!code) return '';
  const upper = String(code).trim().toUpperCase();
  if (upper.length !== 3) return '';
  return NOC_ALPHA3_TO_ALPHA2[upper] || countries.alpha3ToAlpha2(upper) || '';
};

/** Official flag assets served locally from public/flags (SVG, named by ISO alpha-2) */
export const getCountryFlagUrl = (code) => {
  const upper = String(code || '').trim().toUpperCase();
  const override = NOC_FLAG_FILE_OVERRIDES[upper];
  const base = process.env.PUBLIC_URL || '';
  const version = `?v=${FLAG_ASSET_VERSION}`;

  if (override) {
    return `${base}/flags/${override}.svg${version}`;
  }

  const alpha2 = countryToAlpha2(code);
  if (!alpha2) return null;
  return `${base}/flags/${alpha2.toLowerCase()}.svg${version}`;
};

/** @deprecated Use CountryFlag image; emoji fallback on some platforms */
export const countryToFlag = (code) => {
  const alpha2 = countryToAlpha2(code);
  if (!alpha2) return '';
  return alpha2
    .split('')
    .map((c) => String.fromCodePoint(0x1f1e6 + c.charCodeAt(0) - 65))
    .join('');
};
